import React from "react";
import { FaWhatsapp } from "react-icons/fa6";

const WhatsAppButton = () => (
  <a
    href="https://api.whatsapp.com/send?phone=254719218783&text=Hello%20there"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 shadow-lg transition-transform hover:scale-105 hover:bg-green-600"
    title="Chat with us on WhatsApp"
    aria-label="Chat with us on WhatsApp"
  >
    <FaWhatsapp size={30} className="text-white" />
  </a>
);

export default WhatsAppButton;
